// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__332TV","errorLogs":"styles_errorLogs__2r3Rd"};